<template>
<div v-if="thread">
  <template v-if="error">{{error}}</template>
  <template v-else>
    <vue-headful :title="htmlDecode(thread.title) + ' — ' + site_title" />
    <Header :breadcrumbs="bread" />

    <!-- awards popup -->
    <DraggableDiv id="thread__awards" style="display: none;">
      <template slot="header">
        <div class="awards_drag" style="cursor: move;" title="Нажмите и задержите для перемещения этого окна">
          <div style="float: right;"><a class="a__uninteractable" href="javascript: dummy()" title="Закрыть окно" @click.prevent="hideAwardsPopup()">[X]</a></div>
          <div>Награды</div>
        </div>
      </template>
      <template slot="main">
        <div id="awards_content">
          <div class="awards_drag">
            <template v-if="awardsname && awardsname.length > 0">
              {{htmlDecode(awardsname)}}
            </template>
          </div>
          <table class="awards_table">
            <tbody>
              <tr>
                <th class="suppress_right_border" width="25%" nowrap="" align="center">Награда</th>
                <th class="suppress_right_border" width="30%" nowrap="" align="center">Изображение</th>
                <th width="45%" nowrap="" align="center">Описание</th>
              </tr>
              <template v-if="awards">
                <template v-for="(award, index) in awards.awards">
                  <tr v-bind:class="{suppress_bottom_border: index < awards.awards.length-1}">
                    <td class="awards_row suppress_right_border" align="center"><b>{{htmlDecode(award.awardtitle)}}</b></td>
                    <td class="awards_row suppress_right_border" align="center"><img :src="publicPath + 'html/awards/' + award.awardimg"></td>
                    <td class="awards_row" align="left">{{htmlDecode(award.description)}}</td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td colspan="3" style="text-align: center;">
                    Загрузка наград...
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>
    </DraggableDiv>

    <!-- pages widget -->
    <ThreadPages :totalItems="thread.numPosts" :prependIntoLink="'index.php?showtopic='+this.$route.query.showtopic" :itemsPerPage="20" />

    <!-- thread main div -->
    <div class="forums">

      <!-- thread title and subtitle -->
      <div class="forum__section_title">
        <img src="../assets/nav_m.gif" /> {{htmlDecode(thread.title)}}<template v-if="thread.description.length > 0">,</template>
        {{htmlDecode(thread.description)}}
        <span style="float: right;"><a>Каскадный</a> · [ <a>Стандартный</a> ] · <a>Линейный</a></span>
      </div>

      <!-- poll here (optional) -->
      <template v-if="thread.poll && thread.poll.choices && thread.poll.choices.length > 0">
        <div class="forum__thread_subtitle thread_poll_title">
          {{htmlDecode(thread.poll.poll_question)}}
        </div>
        <div class="thread_poll_subtitle"></div>
        <table cellspacing="1" class="thread__poll_table">
          <tbody>
            <tr v-for="(pollChoice, index) in thread.poll.choices">
              <td width="30%" :class="{thread__poll_first_entry: index === 0}" class="thread_poll_first_column">{{htmlDecode(pollChoice.choice)}}</td>
              <td width="3%" :class="{thread__poll_first_entry: index === 0}" class="thread__poll_middle">[ <b>{{htmlDecode(pollChoice.votes)}}</b> ]</td>
              <td width="30%" :class="{thread__poll_first_entry: index === 0}">
                <img src="../assets/bar_left.gif" />
                <img src="../assets/bar.gif" :width="pollChoice.votes / thread.poll.votes * 400" height="11" />
                <img src="../assets/bar_right.gif" />
                [{{parseFloat(pollChoice.votes / thread.poll.votes * 100).toFixed(2)}}%]
              </td>
            </tr>
            <tr>
              <td colspan="3" class="thread__poll_middle"><b>Всего голосов: {{thread.poll.votes}}</b></td>
            </tr>
            <tr>
              <td colspan="3" class="thread__poll_bottom_decorator"></td>
            </tr>
          </tbody>
        </table>
      </template>
      <!-- end of poll -->

      <div class="forum__thread_subtitle">
        <a>Подписка на тему</a> | <a>Сообщить другу</a> | <a>Версия для печати</a> | <a>Кто просматривал тему</a>
      </div>
      <!-- end of thread title -->

      <!-- foreach post -->
      <table v-for="(post, index) in thread.posts" cellspacing="1">
        <tbody>
          <!-- row: poster name, date, post number -->
          <tr class="forum__thread_row_top">
            <td width="1%" align="center">
              <template v-if="post.author_id > 0">
                <a :href="'index.php?showuser=' + post.author_id"><b>{{htmlDecode(post.name) + ' '}}</b></a>
              </template>
              <template v-else>
                {{htmlDecode(post.name) + ' '}}
              </template>
              <!-- TODO: v-if offline/online -->
              <img src="../assets/p_offline.gif" :title="'User is offline'">
            </td>
            <td width="99%" valign="top">
              <!-- POSTED DATE DIV -->
              <div class="thread__post_date_flex">
                <div>
                  <img src="../assets/to_post_off.gif" style="margin-top: 2px;"> {{post.post_date | formatDate}}
                </div>
                <div class="last_elem">
                  Отправлено <a :id="post.pid" title="Ссылка этого сообщения" :href="'#' + post.pid">#{{index+1+skipThreads}}</a>
                </div>
              </div>
            </td>
          </tr>

          <!-- row: avatar, post, etc -->
          <tr class="forum__thread_row_mid">
            <!-- AVATAR, etc... -->
            <td class="thread__poster_info_box" valign="top" align="center">

              <!-- AVATAR -->
              <template v-if="post.avatar !== null && post.avatar.length > 0 && post.avatar !== 'noavatar'">
                <img class="avatar" :src="fixAvatarPath(post.avatar)" />
              </template>
              <br>
              <br>
              <!-- title -->
              <template v-if="post.title !== null && post.title.length> 0">{{htmlDecode(post.title)}}</template> <!-- custom title -->
              <template v-else>{{getTitleFromPosts(post.posts)}}</template> <!-- normal title -->
              <br>
              <!-- PIPS -->
              <div>
                <img v-for="n in getPipsFromPosts(post.posts)" src="../assets/pip.gif" :alt="n | consumeN">
              </div>
              Сообщений: {{post.posts | formatInt}}<br>
              Золото: <b><span style="color: gold;">{{post.author_id === 379 ? '&infin;' : post.gold | formatInt}}</span></b><br> <!-- ranma special case: infinite gold -->
              <!-- awards -->
              <template v-if="post.awards > 0">
                Награды:
                <a class="forum__thread_awards" @click.prevent="showAwardsPopup(post.author_id, post.name, $event)" :href="'javascript: PopAwards('+post.author_id+')'">
                  {{post.awards}}
                </a>
              </template>
              <br>
              <br><br>
              <div style="width: 160px;">
                Предупреждения:<br>
                (<a @click.prevent="openWarningsPopup(post.author_id)" :href="'index.php?act=warn&mid=' + post.author_id">{{post.warn_level*20}}</a>%) <img :src="publicPath + 'warn' + post.warn_level + '.png'">
              </div>
            </td>
            <!-- POST -->
            <td class="thread__posttext" width="100%" valign="top">
              <!-- THE POST -->
              <div v-html="fixVariousTags(fixNewsTags(fixRpgplanetLinks(fixSmileysPath(post.post)), post))"></div>

              <!-- edited by... Сообщение отредактировал virus_found - 29 September 2004, 00:42  -->
              <div v-if="post.append_edit" class="thread__edit_by">
                <br>
                Сообщение отредактировал <b>{{htmlDecode(post.edit_name)}}</b> - {{post.edit_time | formatDate}}
              </div>

              <!-- Signature -->
              <div class="thread__signature" v-if="post.use_sig && post.signature && post.signature.length > 0">
                <br><br>
                --------------------
                <br>
                <div v-html="fixVariousTags(fixRpgplanetLinks(post.signature))"></div>
              </div>
            </td>
          </tr>

          <!-- row: warnings, buttons: PM, quote, reply, etc... -->
          <tr class="forum__thread_row_bottom">
            <td></td>
            <!-- another way of doing warnings
            <td style="text-align: center; font-size: 11px;">
              <a @click.prevent="showWarningPopup(post.author_id, post.name, $event)" :href="'javascript: PopWarnings('+post.author_id+')'"><img :src="publicPath + 'warn' + post.warn_level + '.png'"></a>
            </td>
          -->
            <td>
              <!--  PM / EMAIL / WWW / MSGR  -->
              <div style="float:left;">
                <img src="../assets/p_up.gif" @click="goToTop()" style="cursor: pointer;" />
                <a :href="'index.php?showuser=' + post.author_id"><img src="../assets/p_card.gif" /></a>
                <a><img src="../assets/p_pm.gif" /></a>
                <template v-if="post.website && post.website.length > 0 && post.website !== 'http://'">
                  <a :href="post.website"><img src="../assets/p_www.gif" /></a>
                </template>
                <img v-if="post.icq_number" src="../assets/p_icq.gif" />
              </div>
              <!-- QUOTE / REPLY -->
              <div align="right">
                <a title="Добавить к многочисленным цитатам">
                  <img src="../assets/p_mq_add.gif" />
                </a>
                <a title="Ответить прямо в этом сообщении">
                  <img src="../assets/p_quote.gif" />
                </a>
              </div>
            </td>
          </tr>

          <!-- row: decorative separator -->
          <tr>
            <td class="thread__end_decorator" colspan="2"></td>
          </tr>

        </tbody>
      </table>

      <!-- end of foreach post -->


    </div> <!-- end of <div class="forums"> -->

    <!-- pages again -->
    <ThreadPages :totalItems="thread.numPosts" :prependIntoLink="'index.php?showtopic='+this.$route.query.showtopic" :itemsPerPage="20" />
</template> <!-- v-else (if no error)-->
<FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="this.queries" />
</div>
</template>

<script>
import DraggableDiv from './DraggableDiv'
import Header from './Header'
import ThreadPages from './ThreadPages'
import FooterPermanent from './FooterPermanent'
import {
  globalFormatDate
} from '../../public/utils.js';

export default {
  components: {
    DraggableDiv,
    Header,
    ThreadPages,
    FooterPermanent
  },
  data: function() {
    return {
      thread: null,
      awards: null,
      awardsname: null,
      bread: null,
      skipThreads: 0,
      error: null,
      footerReady: false
    }
  },
  async created() {
    console.time("PageLoadTime");
    let response = null;
    let dateEarly = new Date();
    let pagenumber = 0;
    if (this.$route.query.st) {
      pagenumber = Number(this.$route.query.st);
      if (!pagenumber)
        pagenumber = 0;
    }

    let threadNumber = 0;
    if (this.$route.query.showtopic) {
      threadNumber = this.$route.query.showtopic.replace(/\D/g, ''); // strip non-numeric characters
    } else {
      threadNumber = this.$route.query.t.replace(/\D/g, ''); // strip non-numeric characters
    }
    threadNumber = Number(threadNumber);
    if (!threadNumber)
      threadNumber = 0;

    response = await fetch(this.getNodePath() + 'thread/' + threadNumber + '/page/' + pagenumber);
    let dateLater = new Date();
    let data = await response.json();
    this.thread = data;
    if (data.error) {
      this.error = data.error;
    } else {
      this.queries = data.queries;
      this.bread = data.bread;
      this.skipThreads = pagenumber;
      this.loadTime = this.spanSeconds(dateEarly, dateLater);
      this.footerReady = true;
    }
    //console.log(data);
    console.timeEnd("PageLoadTime");

    // if we have a link ending with e.g. #1234 (post number)
    if (location.hash) {
      this.$nextTick(() => {
        const postId = location.hash.substring(1);
        const element = document.getElementById(postId);
        element.scrollIntoView();
      });
    }
  },
  methods: {
    hideAwardsPopup() {
      let awardsBlock = document.getElementById("thread__awards");
      awardsBlock.style.display = "none";
      this.awards = null;
      this.awardsname = null;
    },
    async showAwardsPopup(posterid, postername, event) {
      //console.log(event.pageX);
      //console.log(event.pageY);
      this.hideAwardsPopup();
      this.awardsname = postername;
      let awardsBlock = document.getElementById("thread__awards");
      awardsBlock.style.display = "block";
      awardsBlock.style.top = event.pageY - 220 + "px";
      awardsBlock.style.left = "155px";
      let awardsResponse = null;
      posterid = Number(posterid);
      awardsResponse = await fetch(this.getNodePath() + 'misc/awards/' + posterid);
      this.awards = await awardsResponse.json();
    },
    async openWarningsPopup(memberId) {
      let myWindow = window.open("/index.php?act=warn&mid=" + memberId, "Warnings", "width=850,height=650");
    },
    fixNewsTags(newsPost, post) { // only affects OP posts
      if (!post.new_topic)
        return newsPost;
      // strip [preview] and [/preview] tags
      return newsPost.replace(/\[preview\](.+?)\[\/preview\]/gi, "$1");
    },
    goToTop() {
      scroll(0, 0);
    },
  },
  filters: {
    consumeN: function(number) {
      return "*";
    }
  }
}
</script>

<style lang="scss">
@import "./Thread.scss";
</style>
